import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

export const StyledTr = styled.tr`
  height: 52px;
  background: ${commonColors.white};

  &:hover {
    background: ${commonColors.grey50};
  }

  > td {
    vertical-align: middle;
    text-align: start;
    padding: 12px 24px;
    color: ${commonColors.grey700};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;

    &:last-child {
      width: 150px;
    }
  }
`;

export const ActionsStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > a {
    display: flex;
    padding: 10px;
    align-items: center;
    > svg {
      path {
        fill: ${commonColors.blue800};
      }
    }
  }

  > button {
    display: flex;
    padding: 0;
    align-items: center;
    cursor: pointer;
    border: none;
    background: none;
    color: ${commonColors.blue800};
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.08px;

    &:first-of-type {
      > svg {
        path {
          fill: ${commonColors.blue800};
        }
      }
    }
    &:last-of-type {
      padding: 10px;
      > svg {
        path {
          fill: ${commonColors.grey600};
        }
      }
    }
    &:disabled {
      cursor: not-allowed;
      > svg {
        g {
          path {
            fill: ${commonColors.grey400};
          }
        }
      }
    }
  }
`;
